var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "col-12 col-md-6 mb-3 card-wrap",
      attrs: {
        "data-topics": _vm.topics,
        "data-cancer-types": _vm.cancer_types,
      },
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.renderModal()
        },
      },
    },
    [
      _c("div", { staticClass: "card p-4 h-100 card-videos bg-white" }, [
        _c(
          "div",
          {
            staticClass:
              "aspect-ratio-box aspect-ratio-box-16x9 patient-education-video-thumbnail",
          },
          [
            _c("img", {
              staticClass:
                "aspect-ratio-box-inner object-fit-cover object-position-center-center",
              attrs: { src: _vm.featured_img, alt: "alt_text" },
            }),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "card-body px-0 py-0 mt-2" }, [
          _vm.title
            ? _c("strong", { staticClass: "card-title mb-0 d-block h6" }, [
                _vm._v(_vm._s(_vm.title)),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.description
            ? _c("div", { staticClass: "card-text" }, [
                _vm._v(_vm._s(_vm.description)),
              ])
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }